/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `DocumentUploadField` for the Caintra Connect frontend.
 * @module components/AppointmentRegistrationSections/Documents/DocumentUploadField
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import FileUploadArea from "../../../modals/ProposalCreateModal/FileUploadArea";

const DocumentUploadField = ({
  fieldKey,
  label,
  file,
  uploadError,
  isUploading,
  isDragging,
  getFieldValidation,
  missingRequiredFields,
  inputId,
  onFileChange,
  onDragOver,
  onDragLeave,
  onDrop,
  onClick,
  isTablet,
  styles,
}) => {
  const validationError =
    getFieldValidation && getFieldValidation(fieldKey) ? " " : "";

  return (
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {label}
        {missingRequiredFields &&
          Object.hasOwn(missingRequiredFields, fieldKey) && (
            <span className={styles.required}> *</span>
          )}
      </label>
      <div className={styles.fileUploadContainer}>
        <FileUploadArea
          file={file}
          isUploading={isUploading}
          isDragging={isDragging}
          error={uploadError || validationError}
          onFileChange={onFileChange}
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          onDrop={onDrop}
          onClick={onClick}
          reduceHeightForTablet={isTablet}
        />
        <input
          id={inputId}
          type="file"
          onChange={onFileChange}
          className={styles.fileInput}
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
};

export default DocumentUploadField;
